import { Directive, OnInit, inject, input, signal } from '@angular/core';

import { Observable } from 'rxjs';

import { CamBaseComponent } from '@camelot/utils';

import { CamSchedulerData } from '../models/scheduler/data';
import { CamPanningsDataService } from '../services/instances.service';

@Directive()
export abstract class AbstractSchedulerComponent extends CamBaseComponent implements OnInit {
  planningId = input.required<string>();

  readonly isReady = signal(false);

  protected _scheduler!: CamSchedulerData;

  private _dataService = inject(CamPanningsDataService);

  ngOnInit() {
    this._scheduler = this._dataService.getScheduler(this.planningId(), true);
    this._registerSubscription(
      this._scheduler.ready$.subscribe({
        next: ready => this.isReady.set(ready),
      })
    );
  }

  public getIsReady$(): Observable<boolean> {
    return this._scheduler.ready$;
  }
}
